import { CountryData } from 'react-phone-input-2'
import getNumWithSpaces from 'prettify-numbers'

import { Delimiters } from '../const/consts'
import { DelimitersType } from '../types'

export const getNumWithDelimiter = (value: string | number, delimiter?: DelimitersType) => {
  return delimiter ? getNumWithSpaces(value, ...delimiter) : getNumWithSpaces(value)
}

export const formatNumber = (value: number, fractionDigits?: number) =>
  getNumWithDelimiter(parseFloat(value.toFixed(fractionDigits || 0)), Delimiters.SPACE_COMMA)

export const formatNumberToMillion = (value: number, fractionDigits?: number) =>
  `${formatNumber(value / 1000000, fractionDigits)}M`

export const formatNumberToThousand = (value: number, fractionDigits?: number) =>
  `${formatNumber(value / 1000, fractionDigits)}К`

export const declOfNum = (value: number, words: string[]) =>
  words[value % 100 > 4 && value % 100 < 20 ? 2 : [2, 0, 1, 1, 1, 2][value % 10 < 5 ? Math.abs(value) % 10 : 5]]

export const cleanObject = (obj: any) => {
  for (const propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined || obj[propName]?.length === 0) {
      delete obj[propName]
    }
  }
  return obj
}

export const omitBy = (obj: any, fieldName: string) => {
  return Object.keys(obj).reduce((acc: any, key) => {
    if (key !== fieldName) {
      acc[key] = obj[key]
    }
    return acc
  }, {})
}

export const omitGroupBy = (obj: any, fieldNames: string[]) => {
  return Object.keys(obj).reduce((acc: any, key) => {
    if (!fieldNames.includes(key)) {
      acc[key] = obj[key]
    }
    return acc
  }, {})
}

export const historyReplaceState = (url: string) => {
  window.history.replaceState(null, '', url)
}

export const getQueryParameter = (name: string) => {
  const match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search)

  return match && decodeURIComponent(match[1].replace(/\+/g, ' '))
}

export const isPhoneNumberValid = (phone: string, country: CountryData) => {
  const minPhoneNumberLength = 7
  const dialCode = country.dialCode

  return !!phone && !!dialCode && phone.length >= minPhoneNumberLength && phone.startsWith(dialCode)
}
